import investorsTemplate from './investors.html';
import investorDetailTemplate from './investorDetail.html';
import investorAddTemplate from './investorAdd.html';

/* @ngInject */
const InvestorsConfig = ($stateProvider) => {
  $stateProvider
    .state('investors', {
      url: '/investors',
      template: investorsTemplate,
      controller: 'InvestorsController',
      controllerAs: 'investors',
      params: {defaultTab: 'PACKAGE'}
    })
    .state('investorAdd', {
      url: '/investors/add',
      template: investorAddTemplate,
      controller: 'InvestorAddController',
      controllerAs: 'investorAdd',
      params: {advindaCount: null, customCount: null}
    })
    .state('investorEdit', {
      url: '/investors/edit/:investorId',
      template: investorAddTemplate,
      controller: 'InvestorAddController',
      controllerAs: 'investorAdd',
      params: {advindaCount: null, customCount: null}
    })
    .state('investorsDetail', {
      url: '/investors/:investorId',
      template: investorDetailTemplate,
      controller: 'InvestorDetailController',
      controllerAs: 'investor',
      params: { isCustomerInvestor: false, advindaCount: null, customCount: null }
    })
    .state('customerInvestorsDetail', {
      url: '/investors/customerInvestors/:investorId',
      template: investorDetailTemplate,
      controller: 'InvestorDetailController',
      controllerAs: 'investor',
      params: { isCustomerInvestor: true, advindaCount: null, customCount: null }
    });
};

export default InvestorsConfig;



/** WEBPACK FOOTER **
 ** ./src/app/components/investors/investors.config.js
 **/